"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselNavControls = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _index = require("../Icon/index");
var _IconButton = require("../IconButton/IconButton");
var _CarouselNavControls = require("./CarouselNavControls.styles");
/**
 * Buttons used to move forward and backward through a carousel of
 * slides. Used by `Carousel`.
 *
 * @since 8.71.0
 */
var CarouselNavControls = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var leftButtonProps = _ref.leftButtonProps,
    rightButtonProps = _ref.rightButtonProps;
  return /*#__PURE__*/_react.default.createElement(_CarouselNavControls.StyledCarouselNavControls, {
    ref: forwardedRef
  }, /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, (0, _extends2.default)({
    "aria-hidden": true,
    appearance: "circle",
    "aria-label": "Previous",
    icon: /*#__PURE__*/_react.default.createElement(_index.IconChevronLeft, null),
    size: "sm",
    tabIndex: "-1",
    title: "Previous items"
  }, leftButtonProps)), /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, (0, _extends2.default)({
    "aria-hidden": true,
    appearance: "circle",
    "aria-label": "Next",
    icon: /*#__PURE__*/_react.default.createElement(_index.IconChevronRight, null),
    size: "sm",
    tabIndex: "-1",
    title: "Next items"
  }, rightButtonProps)));
});
exports.CarouselNavControls = CarouselNavControls;
CarouselNavControls.displayName = 'CarouselNavControls';
CarouselNavControls.propTypes = {
  /**
   * Props passed by `Carousel`. Contains `onClick` and `disabled`.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  leftButtonProps: _propTypes.default.object,
  /**
   * Props passed by `Carousel`. Contains `onClick` and `disabled`.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  rightButtonProps: _propTypes.default.object
};